import { useEffect, useState } from 'react';

import { getWindow } from '@/utils/dom';

export function useMediaQuery(mediaQueryString: string): boolean {
  const [matches, setMatches] = useState(() => getWindow()?.matchMedia(mediaQueryString).matches ?? false);

  useEffect(() => {
    const matchedMedia = window.matchMedia(mediaQueryString);

    setMatches(matchedMedia.matches);

    const eventListener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    matchedMedia.addEventListener('change', eventListener);

    return () => {
      matchedMedia.removeEventListener('change', eventListener);
    };
  }, [mediaQueryString]);

  return matches;
}
